<template>
    <div class="search-items">
        <div class="columns">
            <div class="column">
                <FormField
                    label="Søg"
                >
                    <InputText
                        placeholder="Søg efter serienummer, model, toldkode, varenummer, beskrivelse, kompatibel model"
                        @input="onSearch($event)"
                        @keyup.enter="onSearch($event.target.value)"
                        v-focus
                    />
                </FormField>
            </div>
        </div>
        <div class="columns" v-if="selectedItem === null">
            <div class="column" v-show="hasPerformedFirstSearch">
                <b-table :data="results"
                         :sticky-header="true"
                         detailed
                         detail-transition="fade"
                         :show-detail-icon="false"
                         :loading="isLoading"
                         :striped="true"
                         detail-key="id"
                >
                    <template #empty>
                        Der blev ikke fundet nogen varer.
                    </template>

                    <b-table-column label="Type" v-slot="props" field="model" sortable>
                        <p @mouseover="previewItem = props.row"
                           @mouseleave="previewItem = null"
                           class="is-clickable"
                        >
                            {{ props.row.model }}
                        </p>
                    </b-table-column>

                    <b-table-column label="Varetype" v-slot="props">
                        <span>
                            {{ props.row.type?.name }}
                        </span>
                    </b-table-column>

                    <b-table-column label="Beskrivelse" v-slot="props" :field="currency === 'DKK' ? 'description_da' : 'description_en'" sortable>
                        <p v-html="currency === 'DKK' ? props.row.description_da : props.row.description_en">
                        </p>
                    </b-table-column>

                    <b-table-column label="" v-slot="props">
                        <template v-if="props.row.type?.key === 'service'">
                            <button @click="onSelectItemService(props.row)" class="button is-primary is-fullwidth">
                                Vælg
                            </button>
                        </template>
                        <template v-if="props.row.type?.key === 'no_serial'">
                            <button @click="props.toggleDetails(props.row)" class="button is-primary is-fullwidth">
                                Vis lokationer
                            </button>
                        </template>
                        <template v-if="props.row.type?.key === 'with_serial'">
                            <button @click="props.toggleDetails(props.row)" class="button is-primary is-fullwidth">
                                Vis serienr.
                            </button>
                        </template>
                    </b-table-column>

                    <template #detail="props">
                        <div v-if="props.row.type.key === 'no_serial'">
                            <b-table :data="props.row.itemLocations">
                                <b-table-column label="Lokation" v-slot="rowData">
                                    <span v-if="rowData.row.location">
                                        {{ rowData.row.location.full_name }}
                                    </span>
                                    <span v-else>
                                        -
                                    </span>
                                </b-table-column>
                                <b-table-column label="Antal" v-slot="rowData">
                                <span>
                                    {{ rowData.row.available }}
                                </span>
                                </b-table-column>
                                <b-table-column v-slot="rowData">
                                    <div class="has-text-right">
                                        <button
                                                class="button"
                                                @click="onSelectItemWithLocation(props.row, rowData.row)">
                                            Vælg
                                        </button>
                                    </div>
                                </b-table-column>
                            </b-table>
                        </div>
                        <div v-if="props.row.type.key === 'with_serial'">
                            <div class="createSerialLink">
                                <a href="#" @click.prevent="onShowCreateSerialModal(props.row)">
                                    Opret serienummer
                                </a>
                            </div>
                            <b-table :data="getForSaleSerials(props.row.serials)" default-sort="status.for_sale" default-sort-direction="desc">
                                <b-table-column label="Serienr." v-slot="rowData" :sticky-header="false" sortable field="serial">
                                    <span v-if="rowData.row.is_ghost">
                                        <em>Intet serienummer</em>
                                    </span>
                                    <span v-else>
                                        {{ rowData.row.serial }}
                                    </span>
                                </b-table-column>
                                <b-table-column label="Lokation" v-slot="rowData" sortable field="location.full_name">
                                    <span v-if="rowData.row.location">
                                        {{ rowData.row.location.full_name }}
                                    </span>
                                    <span v-else>
                                        -
                                    </span>
                                </b-table-column>
                                <b-table-column v-slot="rowData" label="Status" sortable field="status.for_sale">
                                    <div class="has-text-right">
                                        <button v-if="rowData.row.status.for_sale" class="button" @click="onSelectItemWithSerial(props.row, rowData.row)">
                                            Vælg
                                        </button>
                                        <span v-else>{{ rowData.row.status.name }}</span>
                                    </div>
                                </b-table-column>
                            </b-table>
                        </div>
                    </template>
                </b-table>
            </div>
        </div>

        <div class="columns" v-if="selectedItem !== null">
            <div class="column">
                <b-table :data="availablePriceTypes" :striped="false">
                    <b-table-column label="Pristype" v-slot="props">
                        <span>
                            {{ props.row.manufacturer_price_type?.name }}
                        </span>
                    </b-table-column>
                    <b-table-column label="Kræver returvare" v-slot="props">
                        <span>
                            {{ props.row.manufacturer_price_type?.price_type.require_return_item ? 'Ja' : 'Nej' }}
                        </span>
                    </b-table-column>
                    <b-table-column label="Pris" v-slot="props">
                        <span :class="{ 'is-outdated': props.row.is_outdated }">
                            {{ props.row.price_display }}
                            <span v-if="props.row.is_outdated" class="block">
                                (Sidst opdateret d. {{ props.row.updated_at }})
                            </span>
                        </span>
                    </b-table-column>
                    <b-table-column v-slot="rowData">
                        <div class="has-text-right">
                            <button class="button" @click="onSelectItemPriceType(rowData.row)">Vælg</button>
                        </div>
                    </b-table-column>
                </b-table>
            </div>
        </div>

        <div class="item-preview-background" v-show="previewItem"></div>
        <div class="item-preview" v-show="previewItem">
            <ItemPreview :item="previewItem"/>
        </div>


        <SerialModal
            :serial="null"
            :item="selectedItemForSerialModal"
            v-if="showCreateSerialModal"
            :active="showCreateSerialModal"
            default-status-key="in_stock"
            :editable-status="false"
            :showAdminFields="false"
            :is-admin="$store.getters.isAdmin"
            @closed="showCreateSerialModal = false"
            @updated="onSerialAdded"
        />
    </div>
</template>

<script>
import debounce from 'lodash/debounce'
import FormField from "../../../elements/form/FormField";
import InputText from "../../../elements/form/InputText";
import Modal from '@elems/modal'
import ItemPreview from "./ItemPreview";
import SerialModal from "../../serials/forms/SerialModal";

export default {
    components: { SerialModal, ItemPreview, InputText, FormField, Modal },
    props: {
        currency: {
            type: String,
            default: 'DKK'
        },
    },
    data() {
        return {
            searchterm: '',
            results: [],
            error: {},
            selectedItem: null,
            selectedItemLocation: null,
            selectedItemSerial: null,
            selectedItemPrice: null,
            isLoading: false,
            hasPerformedFirstSearch: false,
            selectedItemForSerialModal: null,
            previewItem: null,
            showCreateSerialModal: false,
            searchId: 0,
        };
    },
    computed: {
        availablePriceTypes() {
            if (!this.selectedItem) {
                return [];
            }

            if (this.selectedItemSerial) {
                return this.selectedItemSerial.prices;
            }

            if (this.selectedItemLocation && this.selectedItemLocation.available <= 0) {
                return [...this.selectedItem.prices.filter(price => price.out_of_stock_sales === true)];
            }

            return [...this.selectedItem.prices];
        },
    },
    methods: {
        onSerialAdded(serial) {
            this.onSelectItemWithSerial(this.selectedItemForSerialModal, serial);
            this.$store.dispatch('setSuccess', 'Serienummeret blev oprettet')
        },
        onShowCreateSerialModal(item) {
            this.selectedItemForSerialModal = item;
            this.showCreateSerialModal = true;
        },
        onSearch(value) {
            this.searchterm = value;
            this.search();
        },
        search: debounce(function () {
            const searchId = ++this.searchId;
            this.resetSelection();

            if (!this.searchterm) {
                this.isLoading = false;
                this.results = [];
            } else {
                this.isLoading = true;
                this.hasPerformedFirstSearch = true;
                const queryRelations = '&per-page=100&with=images,manufacturer,type,prices.manufacturerPriceType,itemLocations,serials,serials.prices.manufacturerPriceType,serials.prices,serials.location,serials.status,localizations.locale';
                window.axios.get(`/api/items?q=${this.searchterm}${queryRelations}`)
                    .then((response) => {
                        if (searchId === this.searchId) {
                            
                            const results = response.data.data.map(item => {
                                item.description_da_raw = item.localizations.find(localization => localization.locale.code === 'da' && localization.key === 'description')?.value;
                                item.description_da = window.nl2br(item.description_da_raw);
                                item.description_en_raw = item.localizations.find(localization => localization.locale.code === 'en' && localization.key === 'description')?.value;
                                item.description_en = window.nl2br(item.description_en_raw);
                                return item;
                            });
                            this.results = results;
                            this.isLoading = false;
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                        this.results = [];
                        this.isLoading = false;
                    })
            }
        }, 200),
        getForSaleSerials(serials) {
            // let filtered = serials.filter(serial => serial.status.for_sale === true);
            let filtered = serials;
            const matchingSerial = filtered.filter(serial => serial.serial === this.searchterm);

            filtered = filtered.filter(serial => serial.serial !== this.searchterm);

            filtered = [...matchingSerial, ...filtered];

            if (matchingSerial.length > 0) {
                return filtered;
            }

            return filtered.sort((a,b) => a.serial - b.serial);
        },
        resetSelection() {
            this.selectedItem = null;
            this.selectedItemLocation = null;
            this.selectedItemSerial = null;
            this.selectedItemPrice = null;
        },
        onSelectItemService(item) {
            this.selectedItem = item;
        },
        onSelectItemWithLocation(item, itemLocation) {
            this.selectedItem = item;
            this.selectedItemLocation = itemLocation;
        },
        onSelectItemWithSerial(item, itemSerial) {
            this.selectedItem = item;
            this.selectedItemSerial = itemSerial;
        },
        onSelectItemPriceType(itemPriceType) {
            this.selectedItemPrice = itemPriceType;
            const payload = {
                item: this.selectedItem,
                price: this.selectedItemPrice,
                serial: this.selectedItemSerial,
                location: this.selectedItemLocation,
            };

            this.$emit('selected', payload);
        }
    }
}
</script>

<style lang="scss">
.search-items {
    position: relative;

    .item-preview {
        background: white;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 10003;
    }

    .item-preview-background {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.03);
        pointer-events: none;
        z-index: 1000;
    }
}

.b-table {
    width: 100%;
}

.createSerialLink {
    text-align: right;
    width: 100%;
    display: inline-block;
    margin-bottom: 10px;
}

.table-wrapper.has-mobile-cards.has-sticky-header {
    height: 400px;
}
</style>
